<template>
  <CCard>
    <CCardHeader class="d-flex justify-content-between align-items-center">
      <h2 class="mb-0">
        Edit Profile
      </h2>

      <div>
        <CButton
          v-if="new_admin.id"
          color="primary"
          class="mr-2"
          @click="$refs.emailModal.open()"
        >
          Change Email
        </CButton>

        <CButton
          v-if="new_admin.id"
          color="primary"
          @click="$refs.pwdModal.open(`/admins/${new_admin.id}/password`)"
        >
          Change Password
        </CButton>
      </div>
    </CCardHeader>
    <CCardBody>
      <form
        v-if="!user_loading"
        autocomplete="off"
        @submit.prevent="submit"
      >
        <CInput
          v-model="new_admin.first_name"
          label="First Name"
          autocomplete="first_name"
          :add-input-classes="{ 'is-invalid': hasError('first_name') }"
          :invalid-feedback="getError('first_name')"
        />
        <CInput
          v-model="new_admin.last_name"
          label="Last Name"
          autocomplete="last_name"
          :add-input-classes="{ 'is-invalid': hasError('last_name') }"
          :invalid-feedback="getError('last_name')"
        />

        <CInput
          v-model="new_admin.email"
          label="Email"
          autocomplete="email"
          disabled
        />

        <CButton
          type="submit"
          color="primary"
          :disabled="saving"
        >
          <CSpinner
            v-if="saving"
            size="sm"
            class="mr-1"
          />
          Save Profile
        </CButton>
      </form>

      <div
        v-else
        class="mb-3"
      >
        <CSpinner
          style="width: 2rem; height: 2rem"
          color="primary"
          grow
        />
      </div>
    </CCardBody>

    <change-password-modal ref="pwdModal" />
    <change-email-modal ref="emailModal" />
  </CCard>
</template>

<script>
import hasApiValidation from '@/mixins/hasApiValidation';
import ChangePasswordModal from '@/components/ChangePasswordModal.vue';
import ChangeEmailModal from '@/components/ChangeEmailModal.vue';

export default {
  name: 'EditAdminProfile',
  components: {
    ChangePasswordModal,
    ChangeEmailModal,
  },
  mixins: [hasApiValidation],
  data() {
    return {
      new_admin: {
        id: null,
        last_name: '',
        first_name: '',
        email: '',
      },
      user_loading: false,
      saving: false,
    };
  },
  mounted() {
    this.user_loading = true;
    this.fetchUser();
  },
  methods: {
    fetchUser() {
      this.$http
        .get('/auth/me/')
        .then(({ data }) => {
          this.new_admin.id = data.data.id;
          this.new_admin.first_name = data.data.first_name;
          this.new_admin.last_name = data.data.last_name;
          this.new_admin.email = data.data.email;
        })
        .finally(() => {
          this.user_loading = false;
        });
    },
    submit() {
      this.update();
    },
    update() {
      this.setErrors({});
      this.saving = true;

      this.$http
        .put('/me/', this.new_admin)
        .then(() => {
          this.$toast.success('Profile updated successfully');
          // Refresh the auth user so the header dropdown shows the new name
          return this.$auth.fetch();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
          this.setErrors(response.data.errors);
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
